import React, { createContext } from 'react'
import { useKeycloak } from '@react-keycloak/web'
import UserServices from './Services/Consumers/UserServices'
import { useIntl } from 'react-intl'
import { NamedRoutes } from './routes'
import { useHistory } from 'react-router-dom'
import SubscriptionServices from './Services/Consumers/SubscriptionServices'

const PageContext = createContext({})

const PageProvider = ({ children, pageAction, pid, adminSectionType, handleNotificationCall }) => {
  const { keycloak } = useKeycloak()
  const intl = useIntl()
  const history = useHistory()
  const [deletePageLoading, setDeletePageLoading] = React.useState(false)
  const [pageDataLoading, setPageDataLoading] = React.useState(false)
  const [pageDataFailure, setPageDataFailure] = React.useState(false)
  const [pageData, setPageData] = React.useState({})

  React.useEffect(() => {
      if (!!pid && !!parseInt(pid)) {
        getPageData()
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const getPageData = () => {
    if (!!keycloak?.authenticated) {
      setPageDataFailure(false)
      setPageDataLoading(true);
      ('subscription' === adminSectionType ? SubscriptionServices : UserServices).getPageData(pid, { headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` } }).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          setPageDataFailure(true)
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            setPageData(result.data.data)
          } else {
            setPageDataFailure(true)
          }
        }
      }).then(() => {
        setPageDataLoading(false)
      })
    }
  }

  const handlePageSubmit = (values, FormikActions) => {
    if (!!keycloak?.authenticated) {
      FormikActions.setSubmitting(true);
      ('subscription' === adminSectionType ? SubscriptionServices : UserServices).submitPage(pid, pageAction === 'edit', values, {
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` }
      }, FormikActions.setSubmitting, null, FormikActions).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
          if (result.response.data && result.response.data.status && result.response.data.status.errors) {
            message = result.response.data.status.errors
          }
          handleNotificationCall({
            type: 'defence',
            message: message,
            color: 'error'
          }, 'error')
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            handleNotificationCall({
              type: 'done',
              message: intl.formatMessage({ id: pageAction === 'edit' ? 'Page.Edit.FormSuccessAlert' : 'Page.Add.FormSuccessAlert' }),
              color: 'success'
            }, 'success')
            history.push(NamedRoutes[adminSectionType].page.list)
          } else {
            handleNotificationCall({
              type: 'defence',
              message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
              color: 'error'
            }, 'error')
          }
        }
      }).then(() => {
        FormikActions.setSubmitting(false)
      })
    }
  }

  const handleDeletePage = (index, data, setData, count, setCount, handleDeletePageDialog) => {
    if (!!keycloak?.authenticated) {
      setDeletePageLoading(true);
      ('subscription' === adminSectionType ? SubscriptionServices : UserServices).deletePage(data[index].id, {
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` }
      }, setDeletePageLoading).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          handleNotificationCall({
            type: 'defence',
            message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
            color: 'error'
          }, 'error')
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            handleNotificationCall({
              type: 'done',
              message: intl.formatMessage({ id: 'Page.Delete.FormSuccessAlert' }),
              color: 'success'
            }, 'success')
            let newData = data
            newData.splice(index, 1)
            setData(newData)
            setCount(--count)
          } else {
            handleNotificationCall({
              type: 'defence',
              message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
              color: 'error'
            }, 'error')
          }
        }
      }).then(() => {
        setDeletePageLoading(false)
        handleDeletePageDialog()
      })
    }
  }

  return (
    <PageContext.Provider value={{
      pageDataLoading: pageDataLoading,
      pageDataFailure: pageDataFailure,
      pageData: pageData,
      pageAction: pageAction,

      handlePageSubmit,

      deletePageLoading: deletePageLoading,
      handleDeletePage
    }}>
      {children}
    </PageContext.Provider>
  )
}
const PageConsumer = PageContext.Consumer

export { PageProvider, PageConsumer }
